import api from '../../services/service'
export default {
  data () {
    return {
      menus: []
    }
  },
  methods: {
    logout () {
      this.$store.commit('clearState')
      this.$router.push('/login')
    },
    Menus () {
      var header = {
        headers: {
          'access-token': this.$store.state.token
        }
      }
      this.$store.state.isLoading = true
      api.getMenus(
        header,
        result => {
          if (result.response === true) {
            this.menus = result.data.menus
            let obj = this.menus.find(o => parseInt(o.group_menu_id) === parseInt(this.$route.meta.group_id))
            if (!obj) {
              if (this.$route.meta.group_id !== 99) {
                this.$router.push('/error')
              }
            }
          } else {
            this.logout()
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted () {
    if (sessionStorage.user) {
      this.$store.state.token = sessionStorage.token
      this.Menus()
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/header.js